import Axios from "axios";

export const axios = Axios.create({
    baseURL: (process.env.GATSBY_STRAPI_API_URL || "https://stingray-app-sjqto.ondigitalocean.app") + "/api",
    headers: { "Content-Type": "application/json" },
});
